/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";
export function getUserSessionInfoText() {
  // Wrap string calculations to ensure that exceptions do not derail the pfs content
  const lines = ["Current User Session State:", `username: ${safeWrap(() => AbWebServices.sessionData.currentUser.username)}`, `clientSessionId: ${safeWrap(() => AbWebServices.getRPCService().clientSessionId ?? "'No Client Session Id Available'")}`, `productInfo: ${safeWrap(() => AbWebServices.sessionData.productInfo.toString())}`];
  return lines.join("\r\n") + "\r\n";
}
function safeWrap(stringFn, exceptionReturnValue = "Unavailable") {
  try {
    return stringFn();
  } catch (ex) {
    return exceptionReturnValue;
  }
}
//# sourceMappingURL=UserSessionInfo.js.map
